import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import { useWorkerSettlemetHelper } from '@/modules/Settlements/components/Main/WorkerSettlementList/WorkerSettlementCard/logic';
import { ISettlements } from '@/modules/Settlements/types';
import { Typography } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import { SETTLEMENT_STATUS } from '@/shared/constant/backendStatus';
import routes from '@/shared/constant/routes';

import Arrow from '~/images/shared/leftArrow.svg';

const WorkerSettlementCard: React.FC<{
  settlement: ISettlements.IWorkerSettlementSchema;
}> = ({ settlement }) => {
  const { t } = useTranslation('common');

  const statusBgColor = SETTLEMENT_STATUS[settlement.status].color;

  const statusTextColor = SETTLEMENT_STATUS[settlement.status].textColor;
  const { getWorkerSettlementCardData } = useWorkerSettlemetHelper();
  const cardData = getWorkerSettlementCardData(settlement);

  return (
    <div className='flex w-full items-center gap-16 rounded-xl border-xs border-background-100 bg-white p-16'>
      <div className='scrollbar-rounded-lg flex w-full items-center justify-between gap-2 overflow-x-auto whitespace-nowrap overflow-y-hidden scrollbar-thin scrollbar-thumb-background-400 scrollbar-h-1 '>
        {Object.entries(cardData).map(([key, value]) => (
          <div key={key} className=' max-w-1/5  flex   flex-col gap-4 '>
            <Typography variant='body2' className='text-text-600'>
              {t(key)}
            </Typography>
            <Typography
              variant='subtitle2'
              className='text-text-default'
              weight='medium'
            >
              {value || '-'}
            </Typography>
          </div>
        ))}
      </div>
      <div
        className=' rounded-lg py-4 px-16 text-center'
        style={{
          backgroundColor: statusBgColor,
          color: statusTextColor,
        }}
      >
        <Typography
          variant='caption'
          weight='bold'
          className='whitespace-nowrap'
        >
          {t(SETTLEMENT_STATUS[settlement.status].label)}
        </Typography>
      </div>

      <div className='w-24'>
        <Link
          prefetch={false}
          legacyBehavior
          href={`${routes.settlements}/${settlement?.id}`}
        >
          <a>
            <BaseIcon
              size='xs'
              svgClasses='ltr:rotate-180 text-primary-default cursor-pointer'
            >
              <Arrow />
            </BaseIcon>
          </a>
        </Link>
      </div>
    </div>
  );
};
export { WorkerSettlementCard };
